// # Libraries
// # ------------------------------------------------------------------------------
import 'bootstrap/load-qtip';

import 'etc/designs/emagazine/clientlibs/publish/js/libs/jquery.dotdotdot.min.js';
import 'etc/designs/emagazine/clientlibs/publish/js/libs/jquery-ui-1.10.4.custom.min.js';
import 'etc/designs/emagazine/clientlibs/publish/js/libs/jquery.slides.js';
import 'etc/designs/emagazine/clientlibs/publish/js/libs/extensions.js';
import 'etc/designs/emagazine/clientlibs/publish/js/libs/jquery.colorbox.js';
import 'etc/designs/emagazine/clientlibs/publish/js/libs/jquery.selectboxit.js';
import 'etc/designs/emagazine/clientlibs/publish/js/libs/breakpoints.js';

import 'etc/designs/emagazine/clientlibs/publish/js/global.js';
import 'etc/designs/emagazine/clientlibs/publish/js/main.js';

import 'etc/designs/base/clientlibs/shared/libraries/SCS.utils.js';
import 'etc/designs/base/clientlibs/shared/vendor/ba-debug.min.js';
import 'etc/designs/forms/clientlibs/shared/js/libraries/SCS.Captcha.js';

// # Terrific Modules
// # ------------------------------------------------------------------------------
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.BackgroundContainer.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.BrightcoveVideo.js';
import 'etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.Captcha.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.ImagesSlider.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Linklist.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Newsitem.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.FileUpload.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.SocialShare.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Splashscreen.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.VideoContainer.js';
import 'etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Selectbox.js';

import CallOut from 'lib/sdx/Tc.Module.CallOut';

const modernTcModules = {
	CallOut,
};
// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';
legacyBootstrapDeferredSingleton(modernTcModules);



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.emag.publish.ts